module.exports = __webpack_public_path__ + "static/atomicDexSmall-835804fdb9ab0599a61a054042ea17d0.svg";